// reducers/index.ts

import { combineReducers } from '@reduxjs/toolkit';
import { ReducersEnum } from '../../tsmodels/ReduxModel';

// reducers
import mainReducer from './mainReducer';

const rootReducer = combineReducers({
  [ReducersEnum.MAIN]: mainReducer,
});

export default rootReducer;
